<template>
	<div id="app">
		<link rel="shortcut icon" href="/favicon.ico">
		<unlock v-if="this.$route.params.action && this.$route.params.action.toLowerCase() === 'unlock'" />
		<check-out v-else-if="this.$route.params.action && this.$route.params.action.toLowerCase() === 'check-out'" />
		<check-in v-else />
	</div>
</template>

<script>
	import checkIn from './components/check-in.vue';
	import checkOut from './components/check-out.vue';
	import unlock from './components/unlock.vue';

	export default {
		name: 'app',
		components: {
			checkIn,
			checkOut,
			unlock
		},
		mounted() {}
	}
</script>

<style lang="less" src="./styles/app.less"></style>